export const cacheLife = {
  FIVE_MINUTES: 60 * 5,
};
